// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  decisionId: __t.u64().primaryKey().name("decision_id"),
  workspaceId: __t.u64().name("workspace_id"),
  roadId: __t.option(__t.u64()).name("road_id"),
  agendaId: __t.option(__t.u64()).name("agenda_id"),
  stepId: __t.option(__t.u64()).name("step_id"),
  kind: __t.string(),
  title: __t.string(),
  bodyMd: __t.string().name("body_md"),
  evidenceRefsJson: __t.string().name("evidence_refs_json"),
  authorAgentId: __t.option(__t.u64()).name("author_agent_id"),
  authorKind: __t.string().name("author_kind"),
  designArchaeology: __t.bool().name("design_archaeology"),
  supersededBy: __t.option(__t.u64()).name("superseded_by"),
  createdAt: __t.i64().name("created_at"),
});
